import EntryEditable from './EntryEditable';
import EntryConst from './EntryConst';

const PredefinedPosition = ({ col, item, index, onChange }) => {
  const isPosition = col.key === `position${item.depth}`;

  return (
    <>
      {col.custom && <>{col.custom(item, col.unit)}</>}
      {isPosition && (
        <EntryConst
          value={item.position}
          unit=""
          className={col.className}
          item={item}
        />
      )}
      {(col.key === 'name' || col.key === 'unit') && (
        <EntryConst
          value={item[col.key]}
          unit=""
          className={col.className}
          item={col.key === 'name' && item}
        />
      )}
      {(col.key === 'amount' ||
        col.key === 'taxRate' ||
        col.key === 'price') && (
        <EntryEditable col={col} item={item} onChange={onChange} />
      )}
    </>
  );
};

export default PredefinedPosition;
